import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shipowners'
})
export class ShipOwnersPipe implements PipeTransform {
  transform(value: string,owners:any): string {
    let Owner =  owners.filter((item:any) => { 
        if(item.id == value){
          return item;
        }
    });
    return Owner[0]?.name;
  }
}